import { createContext, useContext } from 'react'

type LayoutContextValue = {
  onSizeNode: (id: string, width: number, height: number) => void
  isLaidOut: boolean
  relayout: (fit?: boolean) => void
  fixedWidth: number
}

const noop = () => {}

export const WorkflowLayoutContext = createContext<LayoutContextValue>({
  onSizeNode: noop,
  isLaidOut: false,
  relayout: noop,
  fixedWidth: 0,
})

export const useWorkflowLayoutContext = () => useContext(WorkflowLayoutContext)
